import { H3 } from "../Headers/Headings";
import { useTranslations } from "../../contexts/Translation";
import { useSurvey } from "../../contexts/Survey";
import { useApiData } from "../../contexts/ApiData";
import Input from "../Forms/Input";
import { useState } from "react";
import Button, { IconButton } from "../Button/Button";
import { ValidationError } from "../../types";
import ErrorText from "../Forms/ErrorText";
import { CheckMark, Edit } from "../Icons";
import Comment from "../Comments/Comment";
import { MAX_REFLECTIONS } from "../../lib/textLimits";

export const Reflections = () => {
  const t = useTranslations("surveys");
  const { put } = useApiData();
  const { survey, canEdit, setSurvey } = useSurvey();
  const [reflections, setReflections] = useState(survey?.reflections || "");
  const [isSaved, setIsSaved] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [errors, setErrors] = useState<ValidationError[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    setIsSaved(false);
    setReflections(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await put(`/survey/${survey?.id}/reflections`, { reflections });
    if (!result) {
      setErrors([{ name: "form", message: t("serverError") }]);
    } else {
      setIsSaved(true);
      if (survey) {
        setSurvey({ ...survey, reflections });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <ErrorText variant='form' error={errors.find((e) => e.name === "form")} />
      <H3 variant='noTop'>
        {t("reflectionsHeading")}
        {canEdit && (
          <IconButton active={isEdit} onClick={() => setIsEdit(!isEdit)}>
            <Edit />
          </IconButton>
        )}
      </H3>
      {canEdit && isEdit ? (
        <>
          <Input type='textarea' name='reflections' maxLength={MAX_REFLECTIONS} value={reflections} handleChange={handleChange} />
          <Button>{t("submitReflections")}</Button> {isSaved && <CheckMark />}
        </>
      ) : (
        <Comment preserveWhitespace>{reflections || t("noReflectionsText")}</Comment>
      )}
    </form>
  );
};
